import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {ApplicationConfig, ENVIRONMENT_INITIALIZER, inject} from '@angular/core';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { TitleStrategy, provideRouter, withComponentInputBinding } from '@angular/router';
import { ErrorInterceptor } from '@core/interceptors/error.interceptor';
import { JwtInterceptor } from '@core/interceptors/jwt.interceptor';
import { RefreshTokenInterceptor } from '@core/interceptors/refresh-token.interceptor';
import { TemplatePageTitleStrategy } from '@core/services/page-title.service';
import { CUSTOM_DATE_FORMATS } from '@shared/services/custom-date-format';
import { provideToastr } from 'ngx-toastr';
import routes from './app.routes';
import {uiIconRegister} from "@shared/icons/ui-icon-register";
import {AuthSessionService} from "@features/auth/auth-session.service";

function initializeEnvironment() {
  inject(AuthSessionService);
  uiIconRegister();
}


export default {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([JwtInterceptor, RefreshTokenInterceptor, ErrorInterceptor])),
    { provide: TitleStrategy, useClass: TemplatePageTitleStrategy },
    provideMomentDateAdapter(CUSTOM_DATE_FORMATS),
    provideToastr(),
    {
      provide: ENVIRONMENT_INITIALIZER,
      multi: true,
      useValue: initializeEnvironment,
    },

  ]
} as ApplicationConfig;
